import { IconBriefcase, IconBuildingStore, IconWorldWww } from '@tabler/icons-react';
import { WP_ICON_NAV } from '../icons/constants.js';
import { Badge, type BadgeTone } from '../primitives/Badge.js';
import styles from './ChannelIndicator.module.css';

export type ChannelLabel = 'ECOMMERCE' | 'SHOWROOM' | 'B2B';

const config: Record<
  ChannelLabel,
  { label: string; tone: BadgeTone; icon: typeof IconWorldWww }
> = {
  ECOMMERCE: { label: 'Site web', tone: 'info', icon: IconWorldWww },
  SHOWROOM: { label: 'Point de vente', tone: 'success', icon: IconBuildingStore },
  B2B: { label: 'B2B', tone: 'neutral', icon: IconBriefcase },
};

export interface ChannelIndicatorProps {
  channel: ChannelLabel;
  size?: 'xs' | 'sm' | 'md';
}

export function ChannelIndicator({ channel, size = 'sm' }: ChannelIndicatorProps) {
  const c = config[channel];
  const Icon = c.icon;
  const fs = size === 'xs' ? 11 : size === 'md' ? 13 : 12;
  return (
    <Badge purpose="type" tone={c.tone} className={styles.wrap} style={{ fontSize: fs }}>
      <Icon {...WP_ICON_NAV} size={12} className={styles.icon} aria-hidden />
      {c.label}
    </Badge>
  );
}

/** Order / sale `channel` string → same styling as {@link ChannelIndicator}; unknown values as neutral pill. */
export function SalesChannelIndicator({ channel, size = 'sm' }: { channel: string | null | undefined; size?: 'xs' | 'sm' | 'md' }) {
  const u = String(channel ?? '').toUpperCase();
  if (u === 'ECOMMERCE' || u === 'SHOWROOM' || u === 'B2B') {
    return <ChannelIndicator channel={u as ChannelLabel} size={size} />;
  }
  const fs = size === 'xs' ? 11 : size === 'md' ? 13 : 12;
  return (
    <Badge purpose="type" tone="neutral" className={styles.wrap} style={{ fontSize: fs }}>
      {channel?.trim() ? channel : '—'}
    </Badge>
  );
}
